import { ILessonMedia } from "@/types/lesson.types";
import Attachment from "../Attachment";
import EmptyState from "../EmptyState";

type Props = {
  attachments: string | ILessonMedia | null;
  className?: string;
};

const LessonAttachments = ({ attachments, className }: Props) => {
  if (!attachments)
    return (
      <EmptyState className={className}>
        <div className="max-w-[240px] font-semibold text-[#2C323C]">
          No attachments
        </div>
      </EmptyState>
    );

  return (
    <div className="flex flex-wrap gap-5">
      <Attachment attachment={attachments} />
    </div>
  );
};

export default LessonAttachments;
